module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0JGMzYwQyIgZD0iTTQxLjIgNWgtNy4zTDMyIDQzaDExTDQxLjIgNXoiLz48cGF0aCBmaWxsPSIjRTY0QTE5IiBkPSJNMzMgMjNoLTR2LTZsLTEyIDZ2LTZMNSAyM3YyMGgyOFYyM3oiLz48cGF0aCBmaWxsPSIjRkZDMTA3IiBkPSJNOSAyN2g0djRIOXptOCAwaDR2NGgtNHptOCAwaDR2NGgtNHpNOSAzNWg0djRIOXptOCAwaDR2NGgtNHptOCAwaDR2NGgtNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/factory.svg
// module id = 4175
// module chunks = 0